/* eslint-disable no-unused-vars */
export enum EntityState {
  All = 'All',
  Open = 'Open',
  Closed = 'Closed',
}
